import styled from 'styled-components';
import { rgba } from 'polished';

export const StyledSidePanel = styled.div`
    width: 350px;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    height: 100%;
    transition: width 250ms ease;
    &.sm{
        width: 250px;
    }
    &.xxxs{
        width: 70px;
        .ui-list-users-actions{
            display: none;
        }
        .s-search-container{
            .icon{
                margin-left: -7px;
            }
        }
        .side-panel-title{
            >span{
                display: none;
            }
            >.icon{
                display: block;
                svg{
                    font-size: 18px;
                }
            }
            .btn{
                position: absolute;
                top: 0;
                right: -20px;
                &.active{
                    .icon{
                        transform: rotate(-180deg);
                    }
                }
            }
        }
    }
    .search-container{
        margin-bottom: 10px;
    }
    .side-panel-container{
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        min-width: 0;
        margin-bottom: 20px;
        &:last-child{
            margin-bottom: 0;
        }
    }
    .side-panel-action{
        background-color: ${({ theme }) => theme.secondaryActive};
        padding: 5px 15px;
        display: flex;
        flex-direction: row;
        border-radius: 30px;
        align-items: center;
    }
    .side-panel-wrapper{
        display: flex;
        flex: 1;
        flex-shrink: 0;
        min-width: 0;
        min-height: 0;
        flex-direction: column;
        margin-right: -20px;
        padding-right: 20px;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto;
        overflow-y: overlay;
        &::-webkit-scrollbar {
            width: 4px;
            &-track {
                border-radius: 4px;
                background: ${({theme}) => rgba(theme.black, 0.15)};
            }
            &-thumb {
                border-radius: 4px;
                background: ${({theme}) => rgba(theme.black, 0.35)};
                &:hover {
                    background: ${({theme}) => rgba(theme.black, 0.45)};
                }
            }
        }
        &-overflow{
            display: flex;
            flex: 1;
            flex-shrink: 0;
            min-width: 0;
            min-height: 0;
            overflow: auto;
            flex-direction: column;
            margin-right: -20px;
            padding-right: 20px;
            position: relative;
            .list-users{
                margin-right: -20px;
                padding-right: 20px;
            }
            .list-user{
                flex: auto!important;
                overflow: unset!important;
                min-height: unset!important;
            }
        }
    }
    .side-panel-title{
        font-size: 24px;
        font-weight: 300;
        position: relative;
        color: ${({ theme }) => theme.black};
        display: flex;
        align-items: flex-start;
        flex-direction: row;
        justify-content: space-between;
        white-space: nowrap;
        .number{
            color: ${({ theme }) => rgba(theme.black, 0.4)};
            font-size: 16px;
        }
        >.icon{
            display: none;
        }
        
    }
}
`;
